import React, { useContext } from "react";
import { CartContext } from "../CartContext";
import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

const WishlistPage = () => {
  const { wishlist, removeFromWishlist } = useContext(CartContext);
  const { currentUser } = useAuth();
  const { t } = useTranslation();

  const handleRemove = (productId) => {
    removeFromWishlist(productId);
  };

  return (
    <Container>
      <h1>{t("wishlistTitle")}</h1>
      {currentUser ? (
        <div className="items">
          {wishlist.length > 0 ? (
            wishlist.map((product) => (
              <div className="item" key={product.id}>
                <Link to={`/products/${product.name}`} className="link-styles">
                  <img src={product.image} alt={product.name} />
                  <h2>{product.name}</h2>
                </Link>
                <button onClick={() => handleRemove(product.id)}>
                  {t("wishlistRemove")}
                </button>
              </div>
            ))
          ) : (
            <p className="empty">{t("wishlistEmpty")}</p>
          )}
        </div>
      ) : (
        <p className="empty">{t("wishlistLogin")}</p>
      )}
    </Container>
  );
};

const Container = styled.div`
  padding: 7em 7%;
  min-height: 60vh;
  h1 {
    font-family: "Comfortaa", sans-serif;
    font-weight: 200;
    font-size: 2.4em;
    text-align: center;
    margin-bottom: 1em;
  }
  .empty {
    text-align: center;
    color: #aaaaaa;
    font-size: 18px;
  }
  .items {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 2em;
    .item {
      width: 220px;
      text-align: center;
      padding: 1em;
      border: 1px solid #555555;
      border-radius: 10px;
      transition: 0.4s;
      &:hover {
        background: #292929;
      }
      img {
        width: 100%;
        height: 150px;
        object-fit: contain;
      }
      h2 {
        font-size: 16px;
        font-family: "Comfortaa", sans-serif;
        margin: 10px 0;
      }
      button {
        background: #d87474;
        color: white;
        border: none;
        padding: 8px 16px;
        border-radius: 5px;
        cursor: pointer;
        transition: 0.4s;
        &:hover {
          background: #c05050;
        }
      }
    }
  }
  .link-styles {
    text-decoration: none;
    color: white;
  }
`;

export default WishlistPage;
